import { useSelector } from "react-redux";

export const useLoginUser = () => {
  const { user,jwtExpired } = useSelector((state) => state.auth);
  const { uiid: loginUserUiid } = user?.data || {};

  return {
    loginUserUiid,
    userData: user?.data || {},
    jwtExpired: jwtExpired,
  };
};
